import { apiAlimentoObtenerListaDelDia, apiAlimentoObtenerTipos } from "../API";
import { _APP_DATA } from "../AppData";
import { IApiResult, ICatalogFood, IFoodMenu } from "../models/Entities";
import { RequestData } from "../utils/RequestData";

// /** `Map<IdComida, ItemComidaCalendario>`
//  * @deprecated use `_mapFoodCalendarMenu` instead
// */
// export var _mapFoodMenu: Map<number, IFoodMenu> = new Map();
type MapFoodCalendarMenuControl = Map<number, Map<number, IFoodMenu>> & {
    getFoodsArray: (idComida: number) => IFoodMenu[];
};
/** `Map<IdComida, Map<IdComidaCal, ItemComidaCalendario>>` */
export const _ALIMENTO_CALENDAR_MENU_MAP: MapFoodCalendarMenuControl = (() => {
    const result: MapFoodCalendarMenuControl = new Map() as any;
    result.getFoodsArray = (idComida: number) => {
        const foodsMap = result.get(idComida);
        if (!foodsMap)
            return [];
        return Array.from(foodsMap.values())
            .sort((a, b) => new Date(a.Inicio).getTime() - new Date(b.Inicio).getTime());
    };
    return result;
})();

let maxUpdatedDayFood: string | null = null;

export function _SvAlimentoObtenerListaDelDia(callback: (resultData: Array<IFoodMenu>) => void) {
    let params = {
        IdEscuela: _APP_DATA.userData.IdKinder,
        IdEscolaridad: _APP_DATA.userData.IdNivel,
        Modificacion: maxUpdatedDayFood
    };

    new RequestData<IApiResult<IFoodMenu[]>>(apiAlimentoObtenerListaDelDia)
        .Params(params)
        .Completion((response, error) => {
            let resultData = response?.Datos || [];
            if (error)
                console.log(error.name, error.message);

            if (resultData.length > 0)
                maxUpdatedDayFood = response?.Maxima || null;

            resultData.forEach(item => {
                let foodsMap = _ALIMENTO_CALENDAR_MENU_MAP.get(item.Identificador);
                if (!foodsMap) {
                    foodsMap = new Map();
                    _ALIMENTO_CALENDAR_MENU_MAP.set(item.Identificador, foodsMap);
                }
                if (!item.EnUso) {
                    // _mapFoodMenu.delete(item.Identificador);
                    foodsMap.delete(item.IDComida);
                } else {
                    // _mapFoodMenu.set(item.Identificador, item);
                    foodsMap.set(item.IDComida, item);
                }
            });

            if (resultData.length > 0 && callback)
                callback(resultData);
        }).Get();
}


export const _ALIMENTO_CATALOGO_MAP: Map<number, ICatalogFood> = new Map();
let maxUpdatedFood: string | null = null;

export function _SvAlimentoObtenerTipos(callback: (resultData: Array<ICatalogFood>) => void) {
    let params = {
        IdEscuela: _APP_DATA.userData.IdKinder,
        IdEscolaridad: _APP_DATA.userData.IdNivel,
        Modificacion: maxUpdatedFood
    };

    new RequestData<IApiResult<ICatalogFood[]>>(apiAlimentoObtenerTipos)
        .Params(params)
        .Identifier("_LoadCatalogFoods")
        .Completion((response, error) => {
            let resultData = response ? response.Datos : [];

            if (error)
                console.log(error.name, error.message);

            let maxDate = response?.Maxima;
            if (resultData.length > 0 && maxDate)
                maxUpdatedFood = maxDate;

            resultData.sort((a, b) => a.IdComida - b.IdComida);

            resultData.forEach(item => {
                if (!item.EnUso)
                    _ALIMENTO_CATALOGO_MAP.delete(item.IdComida);

                else
                    _ALIMENTO_CATALOGO_MAP.set(item.IdComida, item);
            });

            if (callback) callback(resultData);
        }).Get();
}

export function _SvAlimentoClearData() {
    maxUpdatedDayFood = null;
    _ALIMENTO_CALENDAR_MENU_MAP.clear();
    maxUpdatedFood = null;
    _ALIMENTO_CATALOGO_MAP.clear();
}